import { addMessages } from '@hana/i18n';

// Chuỗi giao diện vùng HANA Box (mã job, tên riêng, dữ liệu mẫu không dịch).
addMessages('vi', {
  'box.st.doneAll': 'Đã xử lý hết thư',
  'box.st.doneAllDesc': 'Không còn thư chưa xử lý trong hộp này.',
  'box.st.viewDone': 'Xem thư đã xử lý',
  'box.st.errTitle': 'Không tải được hộp thư',
  'box.st.errDesc': 'Mất kết nối tới máy chủ thư lúc 09:02. Thư đang hiện là bản lúc 08:58; thư gửi lúc này vào hàng chờ.',
  'box.st.loading': 'Đang tải thư',
  'box.st.errDescPad': 'Mất kết nối máy chủ thư lúc 09:02. Đang hiện bản lúc 08:58; thư gửi lúc này vào hàng chờ.',
  'box.st.errDescPhone': 'Đang hiện bản lúc 08:58. Thư gửi lúc này vào hàng chờ.',
  'box.noMoney': 'Không trả số tiền',
  'box.noConv': 'Chưa có hội thoại',
  'box.askLost': 'Mất kết nối Ask HANA',
  'box.retry': 'Thử lại',
  'box.askNoPerm': 'Chưa được cấp quyền Ask HANA',
  'box.askNoPermHint': '· nhờ ADMIN gán ghế',
  'box.askAnything': 'Hỏi gì cũng được',
  'box.askGuard': 'Không tự thực thi · không trả số tiền',
  'box.cancel': 'Huỷ',
  'box.openInEzy': 'Mở trong Ezy ↗',
  'box.openAt': 'Mở ở',
  'box.askNew': 'Hỏi mới',
  'box.history': 'Lịch sử',
  'box.shortcuts': 'Lối tắt',
  'box.zone': 'Vùng',
  'box.unassigned': 'Chưa gán',
  'box.askTeam': 'Hỏi nhóm',
  'box.downloadAll': 'Tải tất cả',
  'box.saveAllToJob': 'Lưu tất cả vào job',
  'box.askSummary': 'Ask HANA · tóm tắt luồng',
  'box.compose': 'Soạn trả lời',
  'box.createTask': 'Tạo việc',
  'box.openAll': 'Mở tất cả',
  'box.mail': 'Thư',
  'box.search': 'Tìm',
  'box.notifications': 'Thông báo',
  'box.newMail': 'Soạn thư',
  'box.noMatch': 'Không có thư khớp bộ lọc',
  'box.pickMail': 'Chọn một thư để đọc',
  'box.done': 'Đã xử lý',
  'box.reply': 'Trả lời',
  'box.replyAll': 'Tất cả',
  'box.forward': 'Chuyển',
  'box.mine': 'Của tôi',
  'box.assignPic': 'Gán PIC',
  'box.more': 'Thêm',
  'box.threadSummary': 'Tóm tắt luồng',
  'box.pushPrompt': 'Bật thông báo thư mới cho máy này.',
  'box.turnOn': 'Bật',
  'box.later': 'Để sau',
  'box.select': 'Chọn',
  'box.filter': 'Lọc',
  'box.blOutside': 'B/L gửi ngoài luồng',
  'box.blOutsideDesc': '· MAITTN gửi HBL HNSGN260639118 cho khách bằng thư thường lúc 08:05.',
  'box.openDocs': 'Mở Chứng từ & B/L',
  'box.detected': 'HANA NHẬN DIỆN TỪ THƯ',
  'box.matchJob': 'Khớp job',
  'box.jobActions': 'Thao tác job',
  'box.sameJob': 'Thư cùng job',
  'box.to': 'Tới:',
  'box.mailbox': 'HỘP THƯ',
  'box.folders': 'THƯ MỤC',
  'box.smartFolders': 'THƯ MỤC THÔNG MINH',
  'box.labels': 'NHÃN',
  'box.storage': 'Dung lượng',
  'box.cleanup': 'Dọn hộp thư',
});
addMessages('en', {
  'box.st.doneAll': 'All mail handled',
  'box.st.doneAllDesc': 'No unhandled mail left in this box.',
  'box.st.viewDone': 'View handled mail',
  'box.st.errTitle': 'Could not load the mailbox',
  'box.st.errDesc': 'Lost connection to the mail server at 09:02. Mail shown is the 08:58 copy; outgoing mail goes to the queue.',
  'box.st.loading': 'Loading mail',
  'box.st.errDescPad': 'Lost connection to the mail server at 09:02. Showing the 08:58 copy; outgoing mail goes to the queue.',
  'box.st.errDescPhone': 'Showing the 08:58 copy. Outgoing mail goes to the queue.',
  'box.noMoney': 'No amounts shown',
  'box.noConv': 'No conversations yet',
  'box.askLost': 'Lost connection to Ask HANA',
  'box.retry': 'Retry',
  'box.askNoPerm': 'Ask HANA access not granted',
  'box.askNoPermHint': '· ask an ADMIN to assign a seat',
  'box.askAnything': 'Ask anything',
  'box.askGuard': 'Never executes on its own · no amounts shown',
  'box.cancel': 'Cancel',
  'box.openInEzy': 'Open in Ezy ↗',
  'box.openAt': 'Open in',
  'box.askNew': 'New question',
  'box.history': 'History',
  'box.shortcuts': 'Shortcuts',
  'box.zone': 'Zone',
  'box.unassigned': 'Unassigned',
  'box.askTeam': 'Ask team',
  'box.downloadAll': 'Download all',
  'box.saveAllToJob': 'Save all to job',
  'box.askSummary': 'Ask HANA · thread summary',
  'box.compose': 'Draft reply',
  'box.createTask': 'Create task',
  'box.openAll': 'Open all',
  'box.mail': 'Mail',
  'box.search': 'Search',
  'box.notifications': 'Notifications',
  'box.newMail': 'Compose',
  'box.noMatch': 'No mail matches the filter',
  'box.pickMail': 'Select a mail to read',
  'box.done': 'Done',
  'box.reply': 'Reply',
  'box.replyAll': 'Reply all',
  'box.forward': 'Forward',
  'box.mine': 'Mine',
  'box.assignPic': 'Assign PIC',
  'box.more': 'More',
  'box.threadSummary': 'Thread summary',
  'box.pushPrompt': 'Turn on new-mail notifications on this device.',
  'box.turnOn': 'Turn on',
  'box.later': 'Later',
  'box.select': 'Select',
  'box.filter': 'Filter',
  'box.blOutside': 'B/L sent outside the flow',
  'box.blOutsideDesc': '· MAITTN sent HBL HNSGN260639118 to the customer by regular mail at 08:05.',
  'box.openDocs': 'Open Documents & B/L',
  'box.detected': 'HANA DETECTED FROM MAIL',
  'box.matchJob': 'Match job',
  'box.jobActions': 'Job actions',
  'box.sameJob': 'Mail on same job',
  'box.to': 'To:',
  'box.mailbox': 'MAILBOXES',
  'box.folders': 'FOLDERS',
  'box.smartFolders': 'SMART FOLDERS',
  'box.labels': 'LABELS',
  'box.storage': 'Storage',
  'box.cleanup': 'Clean up mailbox',
});
